import React from "react";
import { Link } from "react-router-dom";
import { ShieldAlert, ArrowLeft } from "lucide-react";

// ═══════════════════════════════════════════════════════════════════════════════
// «NO TIENES ACCESO» NO ES «NO SE PUDO CARGAR» — UNA sola implementación (COL.12)
//
// 🔴 EL DEFECTO QUE ARREGLA, medido en producción el 16 Sep 2026: un colaborador sin
//    `configuracion` que llegaba a /app/asistente veía en rojo «No se pudo cargar la
//    configuración del asistente». Ese texto describe un fallo de red o de servidor, así
//    que la persona reporta una avería que no existe y el administrador busca un problema
//    en el panel. El servidor estaba haciendo exactamente lo suyo: 403.
//
// 🔴 Y NO ERA UNA PANTALLA: el censo dio 14 con capacidad y 12 pintan el mismo lenguaje de
//    avería ante cualquier error («No se pudo cargar…», «Error al cargar…»). Por eso esto
//    es UNA pieza compartida y no catorce parches -- tres copias del mismo texto ya son
//    tres sitios que se desincronizan (la lección de DT.235 y del banner de COL.11), y
//    aquí serían doce.
//
// 🔴 EL TEXTO DEL MOTIVO LO PONE EL BACKEND, no este componente. `detail` llega del 403
//    (`CAPACIDAD_REQUERIDA`, redactado ya para una persona) y se pinta tal cual; el
//    frontend aporta lo único que el servidor no puede saber: la ACCIÓN siguiente. Es la
//    misma regla que gobierna los errores de `/whatsapp/connect` -- duplicar el mensaje
//    aquí crearía dos fuentes que se desincronizan, como `DOCTOR_PLAN_LIMITS`.
//
// ⚠️ `detail` NO siempre existe, y por eso hay un texto de reserva: cuando el guardia de
//    ruta corta antes de pedir nada (el camino normal), no hubo respuesta del servidor que
//    citar. Es el ÚNICO texto propio de todo esto, y vive en un solo sitio.
//
// ⚠️ Esconder no es un permiso y esto tampoco lo es: el servidor ya rechaza en tres capas
//    (COL.9). Lo que esta pantalla evita es que una puerta cerrada se lea como una avería.
// ═══════════════════════════════════════════════════════════════════════════════

export default function SinAcceso({ detail, capacidad, titulo }) {
  return (
    <div className="p-6 lg:p-8 max-w-2xl mx-auto w-full" data-testid="sin-acceso">
      <div className="rounded-2xl border border-amber-300 bg-amber-50 p-6">
        <p className="font-semibold text-amber-900 flex items-center gap-2">
          <ShieldAlert className="w-5 h-5 shrink-0" />
          {titulo || "Esta sección no está en tu acceso"}
        </p>

        {/* El motivo, con las palabras del servidor cuando las hay. */}
        <p className="text-sm text-amber-900 mt-2">
          {detail ||
            "Tu cuenta no tiene el permiso que esta sección necesita. No es un error: " +
              "así está configurado tu acceso."}
        </p>

        {/* Lo que el servidor no puede decir: qué hacer ahora. */}
        <p className="text-sm text-amber-800 mt-3">
          Si necesitas entrar aquí, pídeselo a quien administra la clínica
          {capacidad ? (
            <>
              {" "}
              — tiene que darte el permiso <strong>{capacidad}</strong> desde Colaboradores.
            </>
          ) : (
            "."
          )}
        </p>

        <Link
          to="/app"
          className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-amber-900 underline"
          data-testid="sin-acceso-volver"
        >
          <ArrowLeft className="w-4 h-4" /> Volver al inicio
        </Link>
      </div>
    </div>
  );
}
